import React, { useCallback, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import CategoriesFilter, {
  SELECTED_CATEGORIES
} from '../../../../features/components/DropdownFilters/components/CategoriesFilter'
import SubCategoriesFilter, {
  SELECTED_SUB_CATEGORIES
} from '../../../../features/components/DropdownFilters/components/SubCategoriesFilter'
import SubSubCategoriesFilter, {
  SELECTED_SUB_SUB_CATEGORIES
} from '../../../../features/components/DropdownFilters/components/SubSubCategoriesFilter'
import LocationsFilter, {
  SELECTED_LOCATIONS
} from '../../../../features/components/DropdownFilters/components/LocationsFilter'
import DropdownFilters from '../../../../features/components/DropdownFilters'
import ProductTagsFilter, { SELECTED_TAG } from '../../../../features/components/Filters/ProductTagsFilter'

import { getAllSubSubCategories } from '../../../../features/components/DropdownFilters/components/SubSubCategoriesFilter/helpers'

import { clearGetMediaSubCategories, getMediaSubCategories } from '../../../../modules/actions/mediaOrdersProducts'
import { selectedControllerIdSelector } from '../../../../modules/selectors/app'
import { mediaSubCategoriesSelector } from '../../../../modules/selectors/mediaOrdersProducts'
import LocationCategoriesFilter, {
  LOCATION_CATEGORIES
} from '../../DropdownFilters/components/LocationCategoriesFilter'
import LocationRegionsFilter, { LOCATION_REGIONS } from '../../DropdownFilters/components/LocationRegionsFilter'
import {
  clearGetMediaProductLocationCategories,
  clearGetMediaProductLocationRegions,
  getMediaProductLocationCategories,
  getMediaProductLocationRegions
} from '../../../../modules/actions/mediaOrdersProductLocations'

const MediaProductsFiltersDropdown = ({ Context }) => {
  const dispatch = useDispatch()
  const controllerId = useSelector(selectedControllerIdSelector)

  const mediaSubCategories = useSelector(mediaSubCategoriesSelector)
  const allSubSubCategories = useMemo(() => getAllSubSubCategories(mediaSubCategories), [mediaSubCategories])

  const fetchOptionsHandler = useCallback(() => {
    dispatch(
      getMediaSubCategories({
        controller: controllerId
      })
    )
    dispatch(
      getMediaProductLocationCategories({
        controller: controllerId,
        ordering: 'name',
        limit: 999
      })
    )
    dispatch(
      getMediaProductLocationRegions({
        controller: controllerId,
        ordering: 'name',
        limit: 999
      })
    )
  }, [dispatch, controllerId])

  useEffect(() => {
    dispatch(clearGetMediaSubCategories())
    dispatch(clearGetMediaProductLocationRegions())
    dispatch(clearGetMediaProductLocationCategories())
  }, [dispatch])

  const filters = useMemo(() => {
    return [
      {
        component: <ProductTagsFilter Context={Context} placeholder="Tags" />,
        title: 'Tags',
        filterName: SELECTED_TAG,
        show: true
      },
      {
        component: <CategoriesFilter Context={Context} />,
        title: 'Categories',
        filterName: SELECTED_CATEGORIES,
        show: true
      },
      {
        component: <SubCategoriesFilter Context={Context} />,
        title: 'Asset Type',
        filterName: SELECTED_SUB_CATEGORIES,
        show: !!mediaSubCategories.length
      },
      {
        component: <SubSubCategoriesFilter Context={Context} />,
        title: 'Asset Subtype',
        filterName: SELECTED_SUB_SUB_CATEGORIES,
        show: !!allSubSubCategories.length
      },
      {
        component: <LocationsFilter Context={Context} placeholder="Location" />,
        title: 'Location',
        filterName: SELECTED_LOCATIONS,
        show: true
      },
      {
        component: <LocationCategoriesFilter Context={Context} placeholder="Location Category" />,
        title: 'Location Category',
        filterName: LOCATION_CATEGORIES,
        show: true
      },
      {
        component: <LocationRegionsFilter Context={Context} placeholder="Location Region" />,
        title: 'Location Region',
        filterName: LOCATION_REGIONS,
        show: true
      }
    ]
  }, [Context, allSubSubCategories.length, mediaSubCategories.length])

  return <DropdownFilters filters={filters} Context={Context} onInitialOpen={fetchOptionsHandler} />
}

export default MediaProductsFiltersDropdown
